<template>
    <div id="version-card" v-animate-css="{ classes: 'fadeInDown', delay: 0, duration: 300 }">
        <div class="avatar-container" v-if="false && version.version === selectedBoard">
            <img
                class="avatar"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWTfCd8SFg2xp8ro3M3KM6PGq1zn8od1kAxNUjpnpbug&s"
            />
        </div>
        <div>
            <span v-if="!isEditName" style="font-weight: bolder; color: black; font-size: 14px; font-weight: 600"
                >v{{ version.version }}</span
            >
            <input
                text-type="h6"
                v-show="isEditName"
                max-length="128"
                font-error="false"
                font-form-error="true"
                font-height="small"
                class="update-name-input"
                v-model="editVersionName"
                v-on:keyup.enter="editNameInputEnterClickHandler"
                ref="nameInput"
            />
            <span
                style="
                    padding: 2px 5px;
                    background: #9ba6b3;
                    font-size: 14px;
                    font-weight: 600;
                    border-radius: 4px;
                    color: #fff;
                "
                v-if="version.version === selectedBoard && !isEditName"
                >{{ $t("chatbotv2.preview") }}</span
            >
            <span
                style="padding: 2px 5px; background: #1c57ff; border-radius: 3px; color: #fff"
                v-if="version.published && !isEditName"
                >{{ $t("chatbotv2.published") }}</span
            >
            <span
                style="
                    padding: 2px 5px;
                    background: #ffd98d;
                    font-size: 14px;
                    font-weight: 600;
                    border-radius: 4px;
                    color: #000;
                "
                v-if="version.isDraft && !isEditName"
                >{{ $t("chatbotv2.draft") }}</span
            >
            <div v-if="!version.isDraft">
                {{ $t("chatbotv2.lastUpdate") }}: {{ $moment(version.publishDate).fromNow() }}
            </div>
        </div>
        <a-popover trigger="click" v-model:visible="popoverVisible" placement="left" :overlayClassName="'no-padding'">
            <div slot="content">
                <div class="list-wrapper">
                    <div class="list">
                        <div
                            class="list-item"
                            v-if="version.published || version.publishDate"
                            @click="reStoreClickHandler"
                        >
                            <md-icon>history</md-icon>
                            <p>{{ $t("chatbotv2.restore") }}</p>
                        </div>
                        <div class="list-item" v-if="!version.isDraft" @click="editNameClickHandler">
                            <md-icon>border_color</md-icon>
                            <p>{{ $t("chatbotv2.editName") }}</p>
                        </div>
                        <div class="list-item" v-if="version.isDraft" @click="publishedClickHandler">
                            <md-icon>send</md-icon>
                            <p>{{ $t("chatbotv2.publish") }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="be-icons"
                @click="
                    (e) => {
                        popoverVisible = true;
                        e.stopPropagation();
                    }
                "
            >
                <md-icon>more_horiz</md-icon>
            </div>
        </a-popover>
        <a-modal
            :title="restoreModalVisible ? $t('chatbotv2.restoreVersion') : $t('chatbotv2.newVersion')"
            wrapClassName="vertical-center-modal"
            v-if="versionModal || restoreModalVisible"
            v-model="restoreModalVisible ? restoreModalVisible : versionModal"
            @ok="modalOkHandler"
            @cancel="
                versionModal = false;
                restoreModalVisible = false;
            "
            :okText="$t('message.ok')"
            :cancelText="$t('message.cancel')"
        >
            <a-form
                v-if="!restoreModalVisible"
                class="d-flex flex-column justify-content-center"
                @submit.prevent="publishHandler"
            >
                <a-input v-model="newVersionName" :placeholder="$t('chatbotv2.versionName')" />
            </a-form>
            <div id="version-card-text">
            <p v-if="restoreModalVisible" style="text-wrap: wrap;">
                {{ $t("chatbotv2.restoreModalText") }}
            </p>
            </div>
        </a-modal>
    </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
    name: "VersionCard",
    props: ["version", "selectedBoard", "storyId", "versionNames"],
    data() {
        return {
            popoverVisible: false,
            editVersionName: this.$t("chatbotv2.versionName"),
            isEditName: false,
            versionModal: false,
            newVersionName: "",
            restoreModalVisible: false,
        };
    },
    methods: {
        ...mapActions({
            publishBoard: "CB/publishBoard",
            updateVersionName: "CB/updateVersionName",
            restore: "CB/restore",
        }),
        publishedClickHandler() {
            this.versionModal = true;
            this.popoverVisible = false;
        },
        reStoreClickHandler() {
            this.restoreModalVisible = true;
            this.popoverVisible = false;
        },
        editNameClickHandler() {
            this.$refs.nameInput.focus();
            this.popoverVisible = false;
            this.isEditName = true;
            this.$emit("selected-name", this.version.version);
        },
        editNameInputEnterClickHandler() {
            this.isEditName = false;
            this.versionNames.filter((name) => {
                if (name === this.editVersionName) return false;
            });
            this.updateVersionName({
                storyId: this.storyId,
                boardId: this.version.version,
                versionName: this.editVersionName,
            });
        },
        publishHandler() {
            this.publishBoard({
                id: this.storyId,
                version: this.version.version,
                publishVersion: this.newVersionName,
            });
            this.versionModal = false;
        },
        restoreHandler() {
            this.restoreModalVisible = false;
            this.restore({ storyId: this.storyId, versionId: this.version.version });
            this.$emit("changeVersion", this.version.version);
        },
        modalOkHandler() {
            if (this.restoreModalVisible) {
                return this.restoreHandler();
            }
            this.publishHandler();
        },
    },
};
</script>
<style lang="scss" scoped>
#version-card {
    .update-name-input {
        background: #fff;
        border: 1px solid #c6cdd4;
        border-radius: 6px;
        color: #22272d;
        display: block;
        font-family: sans-serif;
        font-weight: 400;
        height: 32px;
        line-height: 35px;
        padding: 0 15px;
        -webkit-transition: border 0.3s;
        transition: border 0.3s;
        width: 100%;

        &:focus {
            border-color: #008aff;
        }
    }
    #version-card-text{
        p{
            margin-bottom: 10px;
            text-wrap: wrap;
        }
        width: 100% !important;
    }

    display: flex;

    .avatar-container {
        .avatar {
            vertical-align: middle;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }

    .be-icons {
        position: absolute;
        top: 1px;
        right: 4px;
        padding: 1px;
        border-radius: 50%;
        transition: 700ms;

        &:hover {
            background-color: #1890ff;

            i {
                color: #fff;
                transition: 700ms !important;
            }
        }
    }
}

.list-wrapper {
    width: 200px;

    .list {
        width: 100%;

        .list-item {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 22px 13px !important;
            font-family: sans-serif;
            font-weight: 400;
            border: none !important;

            i {
                margin: 0;
                margin-right: 10px;
                color: #516173;
                font-size: 19px;
            }

            p {
                margin: 0;
                color: #22272d;
                font-size: 14px;
                line-height: 18px;
            }

            &:hover {
                background: #fff !important;

                i {
                    color: #066dff;
                    transition: 300ms !important;
                }

                p {
                    color: #066dff;
                    transition: 300ms;
                }
            }
        }
    }
}
</style>
